<label class="font-normal">(You can enter {{charsReamining}} characters.)</label>